import React, { useEffect, useState } from "react";
import {
  Switch,
  Route,
  NavLink,
  useRouteMatch,
  Redirect
} from "react-router-dom";
import { Menu, Dimmer, Loader, Message } from "semantic-ui-react";
// sub views
import ImportProfile from "../../../../components/Configuration/ImportProfile";
import { useAuth } from "../../../../AuthenticationStore";

export default function SMSConfiguration() {
  const { configurationService } = useAuth();
  const [loading, setLoading] = useState(true);

  const [providers, setProviders] = useState([]);
  const [providerId, setProviderId] = useState("");
  const [provider, setProvider] = useState(0);

  const [dataSource, setDataSource] = useState({});

  const [originalConfiguration, setOriginalConfiguration] = useState([]);

  const loadProviders = async () => {
    const response = await configurationService.getProvidersIntegration(4);
    if (response && response.object) {
      setProviders(response.object);
    }
  };

  const loadConfiguration = async () => {
    const response = await configurationService.getConfiguration();
    if (response && response.object) {
      setOriginalConfiguration(response.object);
      // set id provider
      if (response.object.sms && response.object.sms.providerId) {
        setProviderId(response.object.sms.providerId);
        setProvider(response.object.sms.provider);
        // read configuration
        const arrayConfig = response.object.sms.disarrayConfiguration || "{}";
        setDataSource(JSON.parse(arrayConfig));
      }
    }
  };

  const loadData = async () => {
    setLoading(true);
    // load data providers
    await loadProviders();
    // load data configuration
    await loadConfiguration();
    // hide loading
    setLoading(false);
  };

  useEffect(() => {
    if (!configurationService) return;
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configurationService]);

  let { path, url } = useRouteMatch();

  const changeProvider = (id, tempProvider) => {
    setProviderId(id);
    setProvider(tempProvider);
  };

  const saveConfiguration = async () => {
    setLoading(true);
    const generalConfig = Object.assign(originalConfiguration, {});

    if (!generalConfig.sms) generalConfig.sms = {};

    generalConfig.sms.disarrayConfiguration = JSON.stringify(dataSource);
    generalConfig.sms.providerId = providerId;
    generalConfig.sms.provider = provider;

    const responseSveConfig = await configurationService.saveConfiguration(
      generalConfig
    );

    if (responseSveConfig && responseSveConfig.cdExceptions) {
      let messages = [];
      for (let i = 0; i < responseSveConfig.cdExceptions.length; i++) {
        messages.push(responseSveConfig.cdExceptions[i]["exception"]);
      }
      setMessagesExepctions(messages);
    }

    setLoading(false);
  };

  const [messagesExepctions, setMessagesExepctions] = useState([]);
  const handleDismissExceptions = () => setMessagesExepctions([]);

  return (
    <div className="card">
      <div className="card-body">
        <Dimmer active={loading} inverted>
          <Loader />
        </Dimmer>
        {messagesExepctions.length > 0 ? (
          <Message
            onDismiss={handleDismissExceptions}
            error
            header="Errores al guardar"
            list={messagesExepctions}
          />
        ) : null}
        <Menu attached="top" tabular>
          <Menu.Item
            name="import-profile"
            as={NavLink}
            to={`${url}/import-profile`}
          >
            Proveedores SMS
          </Menu.Item>
        </Menu>
        <Switch>
          <Redirect exact from={path} to={`${path}/import-profile`} />
          <Route path={`${path}/import-profile`}>
            <ImportProfile
              providerProp={providerId}
              providersProp={providers}
              changeProvider={changeProvider}
              notProperties
            />
          </Route>
        </Switch>
        <button
          className="btn btn-primary"
          disabled={loading}
          onClick={saveConfiguration}
        >
          Guardar
        </button>
        &nbsp;&nbsp;
        <NavLink className="btn btn-danger" to="/campaigns">
          Salir
        </NavLink>
      </div>
    </div>
  );
}
